import React, { useEffect, useRef } from "react";
import Nft from "./Nft";
import s from "./Shop.module.scss";
import { useNavigate } from "react-router-dom";

const Shop = () => {
  const navigate = useNavigate();
  const containerRef = useRef(null);

  function handleBack() {
    navigate(-1);
    console.log("Back button pressed");
  }

  useEffect(() => {
    if (window.Telegram?.WebApp) {
      window.Telegram.WebApp.BackButton.show();
      window.Telegram.WebApp.BackButton.onClick(handleBack);
    }

    const preventTouchMove = (e) => e.preventDefault();
    window.addEventListener("touchmove", preventTouchMove, { passive: false });

    const container = containerRef.current;
    const allowTouchMove = (e) => {
      if (container.contains(e.target)) {
        e.stopPropagation();
      }
    };

    if (container) {
      container.addEventListener("touchmove", allowTouchMove, { passive: false });
    }

    return () => {
      if (window.Telegram?.WebApp) {
        window.Telegram.WebApp.BackButton.offClick(handleBack);
      }
      window.removeEventListener("touchmove", preventTouchMove, { passive: false });
      if (container) {
        container.removeEventListener("touchmove", allowTouchMove, { passive: false });
      }
    };
  }, [navigate]);

  return (
    <div className={s.miner}>
      <div className={s.container} ref={containerRef}>
        <Nft Func={handleBack} />
      </div>
    </div>
  );
};

export default Shop;
